
import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Util from '@/utils/util';

@Component({
  components: { DateTimePicker },
})
export default class PopularProductUrlForm extends Vue {
  @Prop({}) private url!: string;

  @Prop({}) private label!: string;

  @Prop({}) private startOn!: string;

  @Prop({}) private endOn!: string;

  @Prop({ default: false }) private loading!: boolean;

  private valid: boolean = false;

  private form = {
    url: this.url,
    label: this.label,
    startOn: this.startOn,
    endOn: this.endOn,
  };

  private rules = {
    url: [this.requiredRule('網址'), this.maxLengthRule('網址', 1000)],
    label: [this.maxLengthRule('標籤標題', 6)],
    startOn: [
      this.requiredRule('上架時間'),
      this.lessThenRule(
        '上架時間',
        '上架時間',
        (vm: PopularProductUrlForm) => vm.form.endOn,
      ),
    ],
    endOn: [
      this.requiredRule('下架時間'),
      this.greaterThenRule(
        '下架時間',
        '下架時間',
        (vm: PopularProductUrlForm) => vm.form.startOn,
      ),
    ],
  };

  private get inputs() {
    return {
      url: this.url,
      label: this.label,
      startOn: this.startOn,
      endOn: this.endOn,
    };
  }

  private get datePeriod() {
    return {
      startOn: this.form.startOn,
      endOn: this.form.endOn,
    };
  }

  @Watch('inputs', { immediate: true })
  private inputsWatcher(val: any) {
    this.form = {
      ...val,
    };
  }

  @Watch('datePeriod')
  private datePeriodWatcher(val: any) {
    const inputs: any[] = (this.$refs.form as any).inputs.filter(
      (i: any) => i.label === '上架時間' || i.label === '下架時間',
    );
    inputs.forEach((input) => {
      input.validate(true);
    });
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private maxLengthRule(column: string, length: number) {
    return (v: any) => Util.isNullOrEmpty(v) || v.length <= length || `${column} 最多 ${length} 字`;
  }

  private lessThenRule(
    column: string,
    column2: string,
    func: (vm: PopularProductUrlForm) => any,
  ) {
    return (v: any) => {
      const c = func(this);
      return !v || !c || v <= c || `${column}要小於${column2}`;
    };
  }

  private greaterThenRule(
    column: string,
    column2: string,
    func: (vm: PopularProductUrlForm) => any,
  ) {
    return (v: any) => {
      const c = func(this);
      return !v || !c || v >= c || `${column}要大於${column2}`;
    };
  }

  private async cancel() {
    await this.$router.back();
  }

  @Emit()
  private async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      return {
        ...this.form,
      };
    }
    return null;
  }
}
